import {InputSProps} from "@FRAMEWORK/ui/types/d";
import {ReactNode} from "react";
import styled from "styled-components";

interface Props extends InputSProps {
	htmlFor?: string;
	children?: ReactNode;
	read?: boolean;
}

const Wrap = styled.div<{read?: boolean}>`
	display: flex;
	line-height: 1;
	align-items: center;
	gap: 10px;

	label {
		display: flex;
		align-items: center;
		line-height: 1;
		cursor: pointer;

		&:has(input[type="radio"]:disabled) {
			cursor: initial;
		}
	}

	input[type="radio"] {
		position: relative;
		flex: 0 0 auto;
		width: 18px;
		height: 18px;
		padding: 0;
		border-radius: 100%;
		cursor: pointer;

		&:before {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			content: "";
			cursor: pointer;
			transition: all 250ms ease;
			box-sizing: border-box;
		}

		&:focus {
			border: 1px solid var(--emp-color);
			outline: none;
		}

		&:checked {
			border: 1px solid var(--emp-color);
			&:before {
				width: 8px;
				height: 8px;
				background-color: var(--emp-color);
			}
		}

		&:disabled {
			background-color: var(--disabled-color);
			cursor: initial;

			&:before {
				background-color: var(--gray-color);
				cursor: initial;
			}
		}
	}
`;

const Radio = ({htmlFor, children, ...props}: Props) => (
	<Wrap>
		<input type="radio" {...props} />
		<label htmlFor={htmlFor}>{children}</label>
	</Wrap>
);

export default Radio;
